import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor (
    public _authService: AuthService,
    private _router: Router) { }

  canActivate (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    //  console.log("AuthGuard ------------")
    //  return this._authService.isLoggedIn
    if (this._authService.isLoggedIn) {
      return true;
    } else {
      // Redireciona apenas se tentar acessar rota protegida e não estiver logado
      this._router.navigate([ 'sign-in' ]);
      return false;
    }

  }

}
